import qfSignals from "quickfire/qf-signals";
import { VEventEnum } from "quickfire/v/enums";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class QuickfireStakeUpdateControl extends AbstractControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        const previousTotalStake = this.options && this.options.getTotalStake();
        const newTotalStake = options.getTotalStake();

        if (newTotalStake !== previousTotalStake) {
            qfSignals.dispatch(VEventEnum.betSizeUpdate, newTotalStake);
        }

        super.updateOptions(options);
    }
}
